import script from "./safeguardProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./safeguardProduct.vue?vue&type=script&setup=true&lang=js"

import "./safeguardProduct.vue?vue&type=style&index=0&id=db767000&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db767000"]])

export default __exports__